import { makeImmutable } from "../../core";
export class ProductCategoryPackagingFeeRequirement {
    constructor(productCategoryIds) {
        this.productCategoryIds = productCategoryIds;
        makeImmutable(this);
    }
    testProduct(productInstance) {
        return this.productCategoryIds.includes(productInstance.productCategoryId);
    }
    testModifier(_modifierInstance, _modifierItemTypeId) {
        return false;
    }
}
